import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认");

import { ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getSupplierBranchList } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'RelationSupplierBranchModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    businessCategory: {
      type: String,
      default: '1'
    },
    beforeSuccess: {
      type: [Function, null],
      default: null
    },
    supplierId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const table = ref();
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    watch(() => props.supplierId, () => {
      var _table$value;

      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    });
    const columns = [{
      type: 'checkbox',
      width: '50px'
    }, {
      title: '发货方名称',
      field: 'branch_name',
      width: '350px'
    }, {
      title: '发货方标识',
      field: 'branch_id'
    }];
    watch(() => props.businessCategory, newVal => {
      var _table$value2;

      columns[1].title = newVal === '3' ? '厂家名称' : '发货方名称';
      columns[2].title = newVal === '3' ? '厂家标识' : '发货方标识';
      (_table$value2 = table.value) === null || _table$value2 === void 0 ? void 0 : _table$value2.loadColumn(columns);
    });
    const tableOptions = getVexTableProps({
      columns,
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSupplierBranchList({
              page: page.currentPage,
              rows: page.pageSize,
              supplierId: props.supplierId
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function confirm() {
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      if (typeof props.beforeSuccess === 'function') {
        if (props.beforeSuccess(selectRows)) {
          emit('success', selectRows);
          visible.value = false;
        }
      } else {
        emit('success', selectRows);
        visible.value = false;
      }
    }

    return (_ctx, _cache) => {
      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.businessCategory === '3' ? '关联厂家' : '关联发货方',
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(visible) ? visible.value = $event : null),
        "destroy-on-close": "",
        "append-to-body": "",
        width: "1000px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        default: _withCtx(() => [_createVNode(_component_vxe_grid, _mergeProps({
          height: "630px",
          ref_key: "table",
          ref: table
        }, _unref(tableOptions)), null, 16)]),
        _: 1
      }, 8, ["title", "modelValue"]);
    };
  }

};